import { render, staticRenderFns } from "./DeskDiseaseManage.vue?vue&type=template&id=17a05b10&"
import script from "./DeskDiseaseManage.vue?vue&type=script&lang=js&"
export * from "./DeskDiseaseManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a05b10')) {
      api.createRecord('17a05b10', component.options)
    } else {
      api.reload('17a05b10', component.options)
    }
    module.hot.accept("./DeskDiseaseManage.vue?vue&type=template&id=17a05b10&", function () {
      api.rerender('17a05b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/deskinfo-manage/components/DeskDiseaseManage.vue"
export default component.exports